// @greenlight-spec: 09-data-brokering.md
// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
import { z } from 'zod';
import { CONNECTION_REQUEST_CAPS, CONNECTION_REQUEST_STATUSES, } from '../types/integration-connection-request.js';
export const ConnectionRequestStatusSchema = z.enum(CONNECTION_REQUEST_STATUSES);
/**
 * The builder-facing catalog projection. Everything a citizen developer's agent
 * needs to name a system it wants connected, and nothing about how IT would
 * connect it: `base_url` templates, placeholders, connection profiles, delivery
 * modes, and engine/port are registration mechanics that belong to IT's wizard.
 * Strict on purpose — a field added to the seed cannot reach a builder by default.
 */
export const CatalogEntrySummarySchema = z.strictObject({
    catalog_key: z.string(),
    display_name: z.string(),
    category: z.string(),
    logo_ref: z.string(),
});
/** What the caller's own request for one catalog key looks like on the wire. */
export const ConnectionRequestSchema = z.object({
    id: z.string().uuid(),
    catalog_key: z.string(),
    display_name: z.string(),
    status: ConnectionRequestStatusSchema,
    reason: z.string().nullable(),
    requested_at: z.string().datetime({ offset: true }),
    decided_at: z.string().datetime({ offset: true }).nullable(),
    // IT's words on the decision this row carries. A decline reason is mandatory
    // precisely so the requester can act on it, so it travels back to them rather
    // than living only in IT's queue.
    decision_note: z.string().nullable(),
});
/** IT's queue row: the request plus who asked and what they said. */
export const ConnectionRequestQueueItemSchema = ConnectionRequestSchema.extend({
    category: z.string(),
    logo_ref: z.string(),
    requested_by: z.object({
        id: z.string().uuid(),
        email: z.string(),
        display_name: z.string().nullable(),
    }),
    decided_by: z
        .object({
        id: z.string().uuid(),
        email: z.string(),
        display_name: z.string().nullable(),
    })
        .nullable(),
});
export const RequestIntegrationConnectionInputSchema = z.strictObject({
    catalog_key: z.string().min(1).max(63),
    reason: z.string().min(1).max(CONNECTION_REQUEST_CAPS.reasonMaxChars).optional(),
});
// Required, unlike an approval's optional note. A decline the requester cannot act on
// is the dead end this request type exists to close, and they can raise the ask again —
// so the useful thing to leave behind is what would change the answer. Trimmed before
// the length check so whitespace cannot stand in for a reason.
export const DenyConnectionRequestSchema = z.strictObject({
    decision_note: z
        .string()
        .transform((note) => note.trim())
        .pipe(z.string().min(1).max(CONNECTION_REQUEST_CAPS.decisionNoteMaxChars)),
});
export const ApproveConnectionRequestSchema = z.strictObject({
    decision_note: z.string().max(CONNECTION_REQUEST_CAPS.decisionNoteMaxChars).optional(),
});
//# sourceMappingURL=integration-connection-request.js.map